<div id="home_text">
    <h3 class="brand-label">APPS-DS</h3>

    <div class="headline-wrapper">
        <h1 i18n="@@heroTitle">
            SENIOR <span class="highlight">SOFTWARE</span> ENGINEER
        </h1>
        <p class="subtitle" i18n="@@heroSubtitle">
            Java / Spring Boot · Angular
        </p>
    </div>

    <div class="cta-container">
        <button class="btn btn-primary" (click)="scrollToSection('works')">
            <span i18n="@@btnProjects">VER PROYECTOS</span>
        </button>

        <button class="btn btn-outline" (click)="scrollToSection('contact')">
            <span i18n="@@btnContact">CONTACTAR</span>
        </button>
    </div>
</div>